import "/__w/1/s/BotFramework-WebChat/packages/component/src/ActivityStatus/ActivityStatus.module_built.css";
const classes = {"activity-status--slotted":"wBpMa5G_activity-status--slotted","activity-status-slot":"wBpMa5G_activity-status-slot","activity-status":"wBpMa5G_activity-status","activity-status__originator--has-link":"wBpMa5G_activity-status__originator--has-link","activity-status__originator":"wBpMa5G_activity-status__originator"}
export default classes

const _activity_status__slotted0 = classes["activity-status--slotted"]
export { _activity_status__slotted0 as "activity-status--slotted" }

const _activity_status_slot0 = classes["activity-status-slot"]
export { _activity_status_slot0 as "activity-status-slot" }

const _activity_status0 = classes["activity-status"]
export { _activity_status0 as "activity-status" }

const _activity_status__originator__has_link0 = classes["activity-status__originator--has-link"]
export { _activity_status__originator__has_link0 as "activity-status__originator--has-link" }

const _activity_status__originator0 = classes["activity-status__originator"]
export { _activity_status__originator0 as "activity-status__originator" }
